import { ODSTextField } from '@telekom-ods/react-ui-kit';
import { type ChangeEvent, type WheelEvent, type ReactElement } from 'react';

interface ODSNumberFieldProps {
  id: string;
  name: string;
  value: string | number | null;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  helperText?: string;
  size?: 'small' | 'large';
  onWheel?: (event: WheelEvent<HTMLInputElement>) => void;
}

export const ODSNumberField = ({
  id,
  name,
  value,
  onChange,
  onBlur,
  label,
  placeholder = '',
  disabled = false,
  helperText = '',
  size = 'small',
  onWheel,
}: ODSNumberFieldProps): ReactElement => (
  <ODSTextField
    inputProps={{
      id,
      type: 'number',
      name: name,
      min: 0,
      onChange,
      onBlur,
      onWheel,
    }}
    placeholderText={placeholder}
    value={value ?? ''}
    labelText={label}
    disabled={disabled}
    mode={helperText ? 'error' : 'informative'}
    supportMessageProps={{
      helperText: helperText,
    }}
    size={size}
  />
);
